<div class="container" *ngIf="error">
  <div class="wrapper">
    <div class="wrapper__content" [class.general-error]="error?.useGeneralErrorLayout || error?.validacionInicial">
      <app-boton-volver *ngIf="error && !error?.useGeneralErrorLayout && !error?.validacionInicial"
        (clickVolver)="goBack()"></app-boton-volver>

      <div class="title-section">
        <span *ngIf="error?.useGeneralErrorLayout"
          class="title-section__icon-wrap title-section__icon-wrap--general-error">
          <icon-info-stem-tramite aria-hidden="true"></icon-info-stem-tramite>
        </span>
        <span *ngIf="error?.useAlertIcon && !error?.useGeneralErrorLayout"
          class="title-section__icon-wrap title-section__icon-wrap--general-error"
          aria-hidden="true">
          <span class="title-section__alert-mark">!</span>
        </span>
        <div class="seccion-icono" *ngIf="!error?.useGeneralErrorLayout && !error?.useAlertIcon">
          <icon-info-circle-tramite class="title-section__icon" aria-hidden="true"></icon-info-circle-tramite>
        </div>
        <h1 class="title-section__heading">{{ error.title }}</h1>
      </div>

      <div class="mb-50">
        <ion-text class="sub-title">
          <div [innerHTML]="error.subtitle"></div>
        </ion-text>
      </div>

      <div *ngIf="error?.tituloLista && error?.lista && error.lista.length > 0" class="seccion-error-lista mb-50"
        [class.error-unico]="error?.lista?.length === 1">
        <p>{{ error.tituloLista }}</p>
        <ul class="error-lista">
          <li *ngFor="let item of error.lista" [innerHTML]="item"></li>
        </ul>
      </div>

      <div *ngIf="error?.useGeneralErrorLayout && error?.infoBoxHtml" class="error-info-box"
        [innerHTML]="error.infoBoxHtml"></div>

      <div class="div-text" *ngIf="!error?.useGeneralErrorLayout">
        <p class="fw-700">¿Que viene ahora?</p>
        <ion-text>
          {{ error.message }}
        </ion-text>
      </div>

      <div class="request-error-actions">
        <button type="button" class="primary-button" *ngIf="error?.textButton && error?.eventClickButton"
          (click)="goToClick(error.eventClickButton)">
          <span>{{ error.textButton }}</span>
          <ion-icon *ngIf="error?.primaryButtonIcon" [name]="error.primaryButtonIcon" class="primary-button__icon"
            aria-hidden="true"></ion-icon>
        </button>
        <button type="button" *ngIf="error?.textButton2 && error?.eventClickButton2" class="secondary-button"
          (click)="goToClick(error.eventClickButton2)">
          {{ error.textButton2 }}
        </button>
      </div>
    </div>
  </div>
</div>